import { render, staticRenderFns } from "./ProjectsOverview.vue?vue&type=template&id=856918a2"
import script from "./ProjectsOverview.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsOverview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProjectsOverview.vue?vue&type=style&index=0&id=856918a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports